module.exports = {"231181001":"兆麟街道地区","231181002":"和平街道地区","231181003":"北岗街道地区","231181004":"庆华街道地区","231181005":"铁西街道地区","231181006":"铁南街道地区","231181101":"通北镇","231181102":"赵光镇","231181103":"海星镇","231181104":"石泉镇","231181105":"二井镇","231181200":"城郊乡","231181201":"东胜乡","231181203":"杨家乡","231181207":"主星乡","231181400":"通北林业局","231181500":"北安管理局局直","231181501":"长水河农场","231181502":"赵光农场","231181503":"红星农场","231181504":"建设农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231181.json
// module id = 886
// module chunks = 0